import { render, staticRenderFns } from "./CargoStatistics.vue?vue&type=template&id=58ae1f08&scoped=true&"
import script from "./CargoStatistics.vue?vue&type=script&lang=js&"
export * from "./CargoStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CargoStatistics.vue?vue&type=style&index=0&id=58ae1f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ae1f08",
  null
  
)

export default component.exports